import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';

function O2TableBody(props) {
  var children = props.children,
      className = props.className,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className"]);

  return /*#__PURE__*/React.createElement("tbody", _extends({}, attributes, {
    className: className
  }), children);
}

O2TableBody.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
export default O2TableBody;